import React, { useState, useEffect, useContext } from 'react';
import '../../css/textheader.css';
import { functionContext } from '../../App'

function TextHeader(props) {

const { togglecompletedlevel, changeLevel } = useContext(functionContext);
const [checkBoxState, setcheckBoxState] = useState(false);

// if (!props.allLevelStatus[props.selectedLevel]?.is_completed) {
//     return <div> Loading! </div> 
// } 
if ((props.allLevelStatus[props.selectedLevel]?.is_completed) === undefined) {
    return <div> Loading! </div>
} 

let checkValue = (props.allLevelStatus[props.selectedLevel].is_completed.toString());
// console.log(checkValue);
let booleanCheckValue = (props.allLevelStatus[props.selectedLevel].is_completed);

function isChecked(e) {
    const isCheckedValue = e.target.checked;
    togglecompletedlevel(props.selectedLevel, isCheckedValue);

    if (isCheckedValue) {
        const maxLevel = Math.max(0, (props.allLevelStatus?.length || 1) - 1);
        const nextLevel = Math.min(props.selectedLevel + 1, maxLevel);
        if (nextLevel !== props.selectedLevel) {
            changeLevel(nextLevel);
        }
    }
}

  return (
    <>
      <div id="text-header">

        <h1 className="text-header-title">
          <span className="text-header-label">Level {props.selectedLevel} : check box if finished</span>
          <span className="text-header-arrow">➔</span>
        </h1>

        <input 
        onChange={(e) => isChecked(e)} 
        type="checkbox" 
        className="checkbox" 
        id={`checkbox_${props.selectedLevel}`} 
        name={`checkbox_${props.selectedLevel}`} 
        value="DONE" 
        checked={booleanCheckValue ? true : false }
        >
        </input>

      </div>
    </>
  )
}

export default TextHeader;
